<template>
    <div v-if="sessionCode" class="inviteShare" :class="{ inviteShareCompact: compact }">
        <details :open="!compact">
            <summary>{{ compact ? 'Invite' : 'Invite players' }}</summary>
            <div class="inviteShareBody">
                <img class="inviteQr" :src="qrImageUrl" alt="Invite QR code" />
                <div class="inviteInfo">
                    <div class="inviteLabel">Session code</div>
                    <div class="inviteCode">{{ upperSessionCode }}</div>
                    <input class="inviteUrl" :value="inviteUrl" readonly @focus="$event.target.select()" />
                    <div class="inviteActions">
                        <button class="btn btn-primary btn-sm" type="button" @click="shareInviteLink">Share</button>
                        <button class="btn btn-secondary btn-sm" type="button" @click="copyInviteLink">Copy link</button>
                    </div>
                    <div v-if="copyStatus" class="inviteStatus">{{ copyStatus }}</div>
                </div>
            </div>
        </details>
    </div>
</template>

<script>
import {state} from '@/engine/state.js'

export default {
    name: 'InviteShare',
    props: {
        compact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            state,
            copyStatus: '',
        }
    },
    computed: {
        sessionCode() {
            return this.state.game && this.state.game.session ? String(this.state.game.session).trim() : '';
        },
        upperSessionCode() {
            return this.sessionCode.toUpperCase();
        },
        inviteUrl() {
            const url = new URL(window.location.href);
            url.search = '';
            url.hash = '';
            url.searchParams.set('hotlink', this.sessionCode);
            return url.toString();
        },
        qrImageUrl() {
            return 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=8&data='
                + encodeURIComponent(this.inviteUrl);
        },
    },
    methods: {
        async copyInviteLink() {
            this.copyStatus = '';
            try {
                await navigator.clipboard.writeText(this.inviteUrl);
                this.copyStatus = 'Link copied.';
            } catch (error) {
                window.prompt('Copy invite link', this.inviteUrl);
                this.copyStatus = 'Copy the link from the dialog.';
            }
        },
        async shareInviteLink() {
            const sharePayload = {
                title: 'Join Bamory',
                text: this.state.game && this.state.game.title ? 'Join ' + this.state.game.title : 'Join this Bamory session',
                url: this.inviteUrl,
            };
            if (navigator.share) {
                try {
                    await navigator.share(sharePayload);
                    return;
                } catch (error) {
                    if (error && error.name === 'AbortError') return;
                }
            }
            await this.copyInviteLink();
        },
    },
}
</script>

<style scoped>
.inviteShare {
    width: min(92vw, 560px);
    margin: 10px auto 14px;
    text-align: left;
}

.inviteShare details {
    background: #2d3a45;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 8px;
    padding: 8px 10px;
}

.inviteShare summary {
    cursor: pointer;
    font-weight: 700;
}

.inviteShareBody {
    display: flex;
    gap: 12px;
    align-items: center;
    padding-top: 10px;
}

.inviteQr {
    width: 132px;
    height: 132px;
    object-fit: contain;
    background: #fff;
    border-radius: 6px;
    padding: 6px;
    flex: 0 0 auto;
}

.inviteInfo {
    min-width: 0;
    flex: 1;
}

.inviteLabel {
    color: #b7c2cc;
    font-size: 0.8rem;
}

.inviteCode {
    font-size: 1.4rem;
    font-weight: 800;
    letter-spacing: 0.05em;
}

.inviteUrl {
    width: 100%;
    margin: 6px 0;
    color: #1c2730;
    background: #eef5f8;
    border: 0;
    border-radius: 4px;
    padding: 6px;
    font-size: 0.85rem;
}

.inviteActions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.inviteStatus {
    margin-top: 5px;
    color: #a9f0d1;
    font-size: 0.82rem;
}

.inviteShareCompact {
    width: auto;
    margin: 0;
    position: relative;
    text-align: left;
}

.inviteShareCompact details {
    padding: 4px 8px;
    background: rgba(0, 0, 0, 0.18);
}

.inviteShareCompact .inviteShareBody {
    position: absolute;
    right: 0;
    top: 38px;
    z-index: 20;
    width: min(92vw, 420px);
    background: #2d3a45;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.inviteShareCompact .inviteQr {
    width: 112px;
    height: 112px;
}

@media (max-width: 520px) {
    .inviteShareBody,
    .inviteShareCompact .inviteShareBody {
        flex-direction: column;
        align-items: stretch;
    }

    .inviteQr {
        align-self: center;
    }
}
</style>
